/* Wondy custom sections — companion mood switcher, eye tracking and ticker duplication */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var instances = [];

  function setBubble(bubble, text) {
    if (!bubble || bubble.textContent === text) return;
    if (reduceMotion) {
      bubble.textContent = text;
      return;
    }
    bubble.classList.add('is-swapping');
    window.setTimeout(function () {
      bubble.textContent = text;
      bubble.classList.remove('is-swapping');
    }, 180);
  }

  function initRoot(root) {
    if (root.__mtReady) return;
    root.__mtReady = true;

    var bot = root.querySelector('.mt-bot');
    if (!bot) return;
    var bubble = root.querySelector('[data-mt-bubble]');
    var desc = root.querySelector('[data-mt-desc]');
    var buttons = Array.prototype.slice.call(root.querySelectorAll('[data-mt-mood-btn]'));
    var cycleItems = Array.prototype.slice.call(root.querySelectorAll('[data-mt-cycle] > li'));

    var moods = [];
    if (buttons.length) {
      moods = buttons.map(function (b) {
        return { mood: b.getAttribute('data-mood'), bubble: b.getAttribute('data-bubble') || '', desc: b.getAttribute('data-desc') || '', btn: b };
      });
    } else {
      moods = cycleItems.map(function (li) {
        return { mood: li.getAttribute('data-mood'), bubble: li.textContent.trim(), desc: '', btn: null };
      });
    }
    if (!moods.length) return;

    var index = 0;
    var timer = null;
    var interacted = false;

    function show(i) {
      index = (i + moods.length) % moods.length;
      var m = moods[index];
      bot.setAttribute('data-mood', m.mood);
      setBubble(bubble, m.bubble);
      if (desc) desc.textContent = m.desc;
      moods.forEach(function (x, k) {
        if (x.btn) x.btn.setAttribute('aria-pressed', k === index ? 'true' : 'false');
      });
    }

    function stop() {
      if (timer) window.clearInterval(timer);
      timer = null;
    }

    function start() {
      if (reduceMotion || interacted || root.getAttribute('data-mt-autoplay') !== 'true') return;
      stop();
      timer = window.setInterval(function () {
        if (document.hidden) return;
        show(index + 1);
      }, 3800);
    }

    buttons.forEach(function (b, k) {
      b.addEventListener('click', function () {
        interacted = true;
        stop();
        show(k);
      });
    });

    bot.addEventListener('click', function () {
      if (!buttons.length) {
        show(index + 1);
        stop();
        window.setTimeout(start, 6000);
      } else {
        interacted = true;
        stop();
        show(index + 1);
      }
    });

    show(0);
    start();
    instances.push({ root: root, bot: bot, stop: stop });
  }

  /* Eyes follow the pointer, gently */
  var pointer = null;
  var ticking = false;
  function updateEyes() {
    ticking = false;
    if (!pointer) return;
    instances.forEach(function (inst) {
      if (!document.body.contains(inst.bot)) return;
      var r = inst.bot.getBoundingClientRect();
      if (r.bottom < 0 || r.top > window.innerHeight) return;
      var cx = r.left + r.width / 2;
      var cy = r.top + r.height / 2;
      var dx = Math.max(-1, Math.min(1, (pointer.x - cx) / (window.innerWidth / 2)));
      var dy = Math.max(-1, Math.min(1, (pointer.y - cy) / (window.innerHeight / 2)));
      inst.bot.style.setProperty('--mt-lx', (dx * 7).toFixed(1) + 'px');
      inst.bot.style.setProperty('--mt-ly', (dy * 5).toFixed(1) + 'px');
    });
  }
  if (!reduceMotion) {
    window.addEventListener(
      'pointermove',
      function (e) {
        pointer = { x: e.clientX, y: e.clientY };
        if (!ticking) {
          ticking = true;
          window.requestAnimationFrame(updateEyes);
        }
      },
      { passive: true }
    );
  }

  /* Ticker: duplicate the group so the loop is seamless */
  function initTicker(el) {
    if (el.__mtReady) return;
    el.__mtReady = true;
    var track = el.querySelector('.mt-ticker__track');
    var group = el.querySelector('.mt-ticker__group');
    if (!track || !group) return;
    var clone = group.cloneNode(true);
    clone.setAttribute('aria-hidden', 'true');
    track.appendChild(clone);
    var min = el.clientWidth * 1.2;
    var guard = 0;
    while (group.offsetWidth * (track.children.length / 2) < min && guard < 6) {
      guard++;
      var a = group.cloneNode(true);
      a.setAttribute('aria-hidden', 'true');
      var b = group.cloneNode(true);
      b.setAttribute('aria-hidden', 'true');
      track.insertBefore(a, track.children[1]);
      track.appendChild(b);
    }
  }

  function initAll(scope) {
    var s = scope || document;
    Array.prototype.forEach.call(s.querySelectorAll('[data-mt-mood-root]'), initRoot);
    Array.prototype.forEach.call(s.querySelectorAll('[data-mt-ticker]'), initTicker);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();

  document.addEventListener('shopify:section:load', function (e) {
    instances = instances.filter(function (i) { return document.body.contains(i.bot); });
    initAll(e.target);
  });
})();
